import systemNotificationsAPI from '@shared/api/systemNotifications'

import { NOTIFICATION } from '@shared/config/constants'

function getMessageSeverity(notificationSeverity) {
  const notificationMapper = {
    INFORMATION: NOTIFICATION.INFO,
    ERROR: NOTIFICATION.ERROR,
    WARNING: NOTIFICATION.WARNING,
    SUCCESS: NOTIFICATION.SUCCESS,
  }
  return notificationMapper[notificationSeverity] || NOTIFICATION.INFO
}

export default function useSystemNotifications() {
  async function getSystemNotifications(language) {
    try {
      const response = await systemNotificationsAPI.getSystemNotifications({ language })

      return response.map(notification => {
        return {
          ...notification,
          level: getMessageSeverity(notification.level),
        }
      })
    } catch (error) {
      console.error(`Can't fetch notifications: ${error}`)
    }
  }

  return {
    getSystemNotifications,
  }
}